import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import { ActivePanel } from '../types';

@customElement('leave-spreadsheet-modal')
export class LeaveSpreadsheetModal extends LitElement {
    static amplitude_callsite: string = 'Leave Spreadsheet Modal';

    @property()
    panel?: ActivePanel;

    @property()
    action?: Function;

    private async handleLeave() {
        this.dispatchEvent(new CustomEvent('closeSpreadsheet', {
            detail: {
                panel: this.panel,
                action: this.action,
            }
        }));
    }

    private async handleStay() {
        this.dispatchEvent(new CustomEvent('closeModal'));
    }

    render() {
        return html`
            <div class="spreadsheet-warn">
                Leave spreadsheet view? <br /> Your changes will not be saved.
                <span class="spreadsheet-warn__actions">
                    <div slot="primaryAction" class="spreadsheet-warn__action">
                        <mwc-button @click="${this.handleLeave}">Leave</mwc-button>
                    </div>
                    <div slot="secondaryAction" class="spreadsheet-warn__action">
                        <mwc-button @click="${this.handleStay}" raised>Stay</mwc-button>
                    </div>
                </span>
            </div>
        `;
    }

    static get styles() {
        return css`
          .spreadsheet-warn {
                padding: 10px 20px;
            }

            .spreadsheet-warn__actions {
                display: flex;
                justify-content: center;
            }

            .spreadsheet-warn__action {
                padding: 10px 20px 0;
            }
        `;
    }
}
